<script>

  import { createEventDispatcher } from "svelte";
  import {testEmail} from "../lib/utils";

  const dispatch = createEventDispatcher();

  export let host;

  $: hostInput = host;
  $: hostValid = true;

  const dispatchEvent = () => {
    if (testEmail(hostInput)) {
      host = hostInput;
      localStorage.setItem("host", host);
    } else {
      hostValid = false;
    }
  };
</script>

<style>
  .dialog-wrapper {
    display: flex;
    flex-flow: column;
    align-items: center;
    background: white;
    border-radius: 20px;
    box-shadow: 0 0 10px -4px rgba(0,0,0,.2);
    padding: 20px 40px 40px 40px;
  }

  .action-title {
    font-weight: 600;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 50px;
    text-align: center;
  }

  button {
    margin-top: 20px;
    width: 100%;
  }
</style>

<div class="dialog-wrapper">
  <div class="action-title">Host Email</div>
  <input bind:value={hostInput} placeholder="Email" class:error={!hostValid} />
  <button on:click={dispatchEvent}>Weiter</button>

</div>

  <div class="info">
      Manche Aktionen haben einen Host, welcher <br/>
      <b>a)</b> die Aktion managed, oder <br/>
      <b>b)</b> die Hilfeleistung empfängt.<br/><br/>
      Hosts können Mails empfangen, um nach der Bestätigung für einen 
      Helfer gefragt zu werden. Dazu musst du die Aktion starten und 
      über die App die Bestätigung anfragen.

      <br/><br/>

      <em>Trage zum testen deine eigene Email ein.  Bitte gehe 
      verantwortungsvoll damit um und trage keine fremde Email ein!</em>
  </div>